import { render, staticRenderFns } from "./ColorSlider.vue?vue&type=template&id=ae7a9612&"
import script from "./ColorSlider.vue?vue&type=script&lang=js&"
export * from "./ColorSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("I:\\web-project\\dream\\tools\\dsf-product-ppt\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae7a9612')) {
      api.createRecord('ae7a9612', component.options)
    } else {
      api.reload('ae7a9612', component.options)
    }
    module.hot.accept("./ColorSlider.vue?vue&type=template&id=ae7a9612&", function () {
      api.rerender('ae7a9612', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/utils/gradualSelect/ColorSlider.vue"
export default component.exports